<div
	[ngClass]="{
		'aspect-classic w-full lg:aspect-[9/4] lg:max-h-200 lg:min-h-146':
			size() === 'large',
		'h-[17rem] md:h-[20rem]': size() === 'small',
	}"
	class="relative flex"
>
	@if (items().length > 1) {
		<div class="absolute left-0 top-1/2 z-10 size-11 translate-y-[-50%]">
			<button
				(click)="slidePrev()"
				aria-label="Previous slide"
				class="elevation-1 flex h-full w-inherit items-center justify-center rounded-r-full bg-[#000]/50 outline-2 outline-offset-2 outline-white focus:outline"
				data-test-id="carousel__prev-button"
				type="button"
			>
				<svg-icon
					class="h-auto w-4 text-white"
					src="assets/icons/icon-chevron-left.svg"
				/>
			</button>
		</div>
		<div class="absolute right-0 top-1/2 z-10 size-11 translate-y-[-50%]">
			<button
				(click)="slideNext()"
				aria-label="Next slide"
				class="elevation-1 flex h-full w-inherit items-center justify-center rounded-l-full bg-[#000]/50 outline-2 outline-offset-2 outline-white focus:outline"
				data-test-id="carousel__next-button"
				type="button"
			>
				<svg-icon
					class="inline-block h-auto w-4 text-white"
					src="assets/icons/icon-chevron-right.svg"
				/>
			</button>
		</div>
	}
	<swiper-container
		#swiper
		class="w-full grow-0 rounded sm:order-2 sm:mb-0"
		init="false"
	>
		@for (item of items(); track item; let i = $index) {
			<swiper-slide
				[ngClass]="{
					'opacity-0': i !== 0,
					'cursor-grab': items().length > 1,
				}"
			>
				<vp-hero-item
					[contentMargin]="contentMargin()"
					[heading]="item.heading"
					[i]="i"
					[image]="item.image"
					[link]="item.link"
					[size]="size()"
					[sticker]="item.sticker"
					[useEagerLoading]="useEagerLoading()"
					[video]="item.video"
				>
					<vp-hero-item-sub-heading>
						{{ item.subHeading }}
					</vp-hero-item-sub-heading>
				</vp-hero-item>
			</swiper-slide>
		}
	</swiper-container>
</div>
